import { stat } from "fs";

const mutations = {
  addUserLimit(state, { arr }) {
    state.userLimit = [...arr];
  },
  addMenu(state, { arr }) {
    state.menuList = arr;
  },
  setHeight(state, num) {
    state.height = num;
  },
  setOldUserSeeAmount(state, oldUserSeeAmount) {
    state.oldUserSeeAmount = oldUserSeeAmount;
  },
  searchParam(state, param) {
    state.searchParams = param;
  },
  areaList(state, list) {
    state.areaList = list;
  },
  searchParamDialog(state, param) {
    state.searchParamDialog = param;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js